<template>
  <section
    class="slide sec1 overflow-hidden kenBurns opacity-0 fixed w-full h-full"
    name="madisonjames"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap table-cell align-middle cursor-default cursor-default">
          <div class="fix-width max-w-1114px ml-auto mr-auto" name="arrow-up" id="mjHuge">
            <h1
              class="tagLineBG ml-spc6 tracking-spc3 text-size3 font-bold font-anonymouse leading-none text-left ae-2 fromLeft opacity-60"
            >{{title1}}</h1>
            <h1
              class="tagLineBG ml-spc6 tracking-spc3 text-size3 font-bold font-anonymouse leading-none text-left ae-2 fromLeft opacity-60"
            >{{title2}}</h1>
            <h1
              class="tagLineBG ml-spc6 tracking-spc3 text-size3 font-bold font-anonymouse leading-none text-left ae-2 fromLeft opacity-60"
            >{{title3}}</h1>
            <h3
              class="subtagsmall ae-3 fromBottom done text-size6 font-anonymouse font-semibold tracking-spc4 opacity-0 text-white text-left ml-spc7 leading-lh1"
            >{{subtitle}}</h3>
          </div>
        </div>
      </div>
    </div>
    <div
      class="background absolute top-0 left-0 w-full h-full bg-center bg-cover bg-no-repeat"
      :style="{backgroundImage: 'url('+bgImg+')'}"
    ></div>
  </section>
</template>

<script>
export default {
  props: ["title1", "title2", "title3", "subtitle", "bgImg"],
  name: "Section1"
};
</script>

<style scoped>
</style>